'use strict';

(function () {
  angular
    .module('specsguardApp')
    .factory('Module', Module);

  Module.$inject = ['$resource'];

  function Module ($resource) {

    return $resource('/api/modules/:id/:controller/:submoduleId',
      {
        id: '@_id',
        submoduleId: '@_submoduleId'
      },

      {
        save: {
          method: 'POST',
          isArray: true,
          params: {
            fullTree: true,
            withElements: true,
          },
        },

        get: {
          isArray: true,
        },
        getOne: {
          method: 'GET',
        },
        delete: {
          method: 'DELETE',
          isArray: true,
          params: {
            fullTree: true,
            withElements: true,
          },
        },
        update: {
          method: 'PATCH',
          isArray: true,
          params: {
            fullTree: true,
            withElements: true,
          },
        },

        createSubmodule: {
          method: 'POST',
          isArray: true,
          params: {
            controller: 'submodule',
            fullTree: true,
            withElements: true,
          }
        },

        updateSubmodule: {
          method: 'PATCH',
          isArray: true,
          params: {
            controller: 'submodule',
            fullTree: true,
            withElements: true,
          },
        },
        deleteSubmodule: {
          method: 'DELETE',
          isArray: true,
          params: {
            controller: 'submodule',
            fullTree: true,
            withElements: true,
          },
        },
      });
  }

})();
